const d3 = require('d3')

function getRootContent() {
  let rootContent = d3.select('.input-sheet');
  if (rootContent.empty()) {
    rootContent = d3.select('body').append('div').attr('class', 'input-sheet');
  }
  return rootContent;
}

function initialisePage(header, subheading) {
  const content = getRootContent();
  addCenteredHeading(content, header);
  addCenteredSubHeading(content, subheading);
  showLoader(content);
}

function showLoader(content) {

  content.append('div').html(`
      <span class="loader-text">
        <div class="loader-wrapper">
          <div style="animation-delay: 0s"></div>
          <div style="animation-delay: 0.25s"></div>
          <div style="animation-delay: 0.75s"></div>
          <div style="animation-delay: 0.5s"></div>
        </div>
      </span>
    `)
}

function hideLoader() {
  const inputSheet = getRootContent();
  if (inputSheet) {
    const loaderDiv = inputSheet.select('.loader-text');
    if (!loaderDiv.empty()) {
      loaderDiv.node().parentNode.remove();
    }
  }
}

function addCenteredHeading(content, heading) {
  content.append('div').attr('align', 'center').html(`<h2>${heading}</h2>`)

  content.append('div').html('<p />')
}

function addCenteredSubHeading(content, subheading) {
  content.append('div').attr('align', 'center').html(`<em>${subheading}</em>`)

  content.append('div').html('<p />')
}

function hideRadarArea() {
  // document.querySelector('.hero-banner').style.display = 'none'
  document.querySelector('main').style.display = 'none'
}

function isViewEnabled(mode) {
  const searchParams = new URL(document.location).searchParams

  return searchParams.get('view') === mode
}

module.exports = {
  addCenteredHeading,
  addCenteredSubHeading,
  hideRadarArea,
  isViewEnabled,
  showLoader,
  hideLoader,
  initialisePage,
  getRootContent
}
